<template>
  <div id="Help">
    <div class="header" v-if="['personal','mdeical','campus','nation'].includes(VUE_PLATFORM_TYPE)">
      <div class="left">
        <img style="width:28px;height:28px;margin-right:42px;"
             src="https://passport.fycat.com/cas/images/baise-logo.png" alt="">
        <div class="title-text" style="font-size:12px;">飞译 — AI辅助工具，人机协作平台</div>
      </div>
      <div class="right">
        <img style="width:14px;height:14px;margin-right:9px;" src="https://passport.fycat.com/cas/images/denglu-tuichu-icon.png" alt="">
        <span v-if="Object.keys(getUserInfo).length === 0" class="login-reg" @click="handlertoLogin">登录&nbsp;|&nbsp;注册</span>
        <span v-else class="login-reg">{{getUserInfo.nickName}}</span>
      </div>
    </div>
    <div class="main">
      <div class="elevator-warp">
        <div class="top-titlt">帮助中心</div>
        <div class="elevator-warp-item" v-for="(item,index) in elevatorList" :key="item.id"
             @click="hanldeElevator(item.code,index)">
          <div class="name" :class="{'elevator-warp-item-bg':index===activeIndex}">
            {{item.name}}</div>
        </div>
      </div>
      <div class="content-view-warp">
        <div class="view-item" v-if="this.activeIndex===0">
          <plat-form-info></plat-form-info>
        </div>
        <div class="view-item" v-for="(item,index) in dataInfo" :key="index"
             :style="item.size?'textAlign:center':''" v-else>
          <h2 class="view-title" v-if="item.type==='title'">
            {{item.content}}
          </h2>
          <img :src="require('./images/'+item.content)" alt="" v-if="item.type==='img'"
               :class="item.size?'view-minimg':'view-img'">
          <div v-if="item.type==='content'" class="view-content">
            {{item.content}}
          </div>
          <div v-if="item.type==='header'" class="view-header">
            <p> {{item.content}}</p>
            <i></i>
          </div>
          <div v-if="item.type==='contentLi'" class="view-content itemli">
            <ul>
              <li v-for="(itemli,index) in item.content" :key="index">
                {{itemli.liname}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="['personal','mdeical','campus','nation'].includes(VUE_PLATFORM_TYPE)">
      <div class="footer-left">
        <div class="footer_site">
          <span><i class="icon_email"></i>kefu@zkfy.com</span>
          <span><i class="icon_phone"></i>010-61934588</span>
          <span><i class="icon_site"></i>北京市海淀区知春路甲63号卫星大厦1006室</span>
        </div>
        <div class="footer_records">
          @2022 北京中科凡语科技有限公司（Beijing Fanyu Technology Co., Ltd）
          <br>
          <a
             href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030832">京公网安备11010802030832号</a>|
          <a href="https://beian.miit.gov.cn/">京ICP备17022088号-2</a>|
          <a href="https://beian.miit.gov.cn/">京ICP备18045685号-4</a>
        </div>
      </div>
      <div class="footer_right">
        <div class="footer_right_tit">
          关注飞译
        </div>
        <div class="footer_code">
          <div class="footer_code_item">
            <img src="https://www.fycat.com/_nuxt/img/fy_code.91b0602.png" alt="飞译二维码">
            <div>飞译公众号</div>
          </div>
          <div class="footer_code_item">
            <img src="https://www.fycat.com/_nuxt/img/zkfy_code.62d9a40.png" alt="中科凡语二维码">
            <div>中科凡语公众号</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpdata from "./helpdata";
import PlatFormInfo from './components/plat-Form-Info';
export default {
  name: "help",
  computed: {
    //获取用户信息
    getUserInfo () {
      return this.$store.getters['layout/getUserInfo']
    },
  },
  data () {
    return {
      activeIndex: 0,
      elevatorList: [
        { id: 1, name: '产品介绍', code: 'platforminfo' },
        { id: 2, name: '注册与登录', code: 'registerlogin' },
        { id: 3, name: '项目管理', code: 'project' },
        { id: 4, name: '我的任务', code: 'mytask' },
        { id: 5, name: '团队管理', code: 'teammanagement' },
        { id: 6, name: '教学管理', code: 'teachingmanagement' },
        { id: 7, name: '译后编辑', code: 'translationeditor' },
      ],
      dataInfo: [],
      VUE_PLATFORM_TYPE: VUE_PLATFORM_TYPE,               // 平台版本
    }
  },
  components: { PlatFormInfo },
  mounted () {
  },
  methods: {
    hanldeElevator (code, index) {
      this.activeIndex = index;
      document.getElementById("Help").scrollTop = 0;
      if (this.elevatorList[this.activeIndex].code !== 'platforminfo') {
        this.dataInfo = helpdata[this.elevatorList[this.activeIndex].code];
      }
      if (this.elevatorList[this.activeIndex].code === 'registerlogin' && !['personal', 'mdeical', 'campus', 'nation'].includes(VUE_PLATFORM_TYPE)) {
        this.dataInfo = helpdata['registerlogin1'];
      }
    },
    handlertoLogin () {
      this.$router.push({ path: "/#/home/homeMiddleware" })
    },

  }
}
</script>
<style lang="less" scoped>
@import "./assets/index.less";
</style>